import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const CampervanIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5 17C17.1193 17 16 18.1193 16 19.5C16 20.8807 17.1193 22 18.5 22C19.8807 22 21 20.8807 21 19.5C21 18.1193 19.8807 17 18.5 17ZM18.5 20.5C17.9477 20.5 17.5 20.0522 17.5 19.5C17.5 18.9477 17.9477 18.5 18.5 18.5C19.0523 18.5 19.5 18.9477 19.5 19.5C19.5 20.0522 19.0523 20.5 18.5 20.5Z"
        fill="currentColor"
      />
      <path
        d="M0 17V18.5C0.552277 18.5 1 18.9477 1 19.5C1 20.0522 0.552277 20.5 0 20.5V22C1.38071 22 2.5 20.8807 2.5 19.5C2.5 18.1193 1.38071 17 0 17Z"
        fill="currentColor"
      />
      <path
        d="M22 13H15V8.5H18L15.5 5.5H11V4H15C15 3.17157 14.3284 2.5 13.5 2.5H0V4H4V5.5H0V16C1.93298 16 3.5 17.567 3.5 19.5H15C15 17.567 16.567 16 18.5 16C20.433 16 22 17.567 22 19.5H24V15L22 13ZM9.5 5.5H5.5V4H9.5V5.5Z"
        fill="currentColor"
      />
    </svg>
  )
})
CampervanIcon.displayName = 'CampervanIcon'
export default CampervanIcon
